import {List} from 'immutable';

import {LIVE_INIT, LIVE_UPDATE} from 'sagas/actions';

import * as LineActions from 'actions/Line';
import * as MatchResultActions from 'actions/MatchResults';
import * as StakeOfTheDayActions from 'actions/StakeOfTheDay';
import * as PopularActions from 'actions/Popular';

export default function matchGroupsReducer(action, matches, groups) {
    switch (action.type) {
        case LIVE_INIT.SUCCESS:
        case LineActions.SUCCESS_REQUEST_LINE_HEADERS:
        case LineActions.SUCCESS_REQUEST_SPORT_LINE_HEADERS:
        case LineActions.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS:
        case MatchResultActions.SUCCESS_FETCH_MATCH_RESULTS:
        case StakeOfTheDayActions.SUCCESS_GET_STAKE_OF_THE_DAY:
        case PopularActions.SUCCESS_GET_POPULAR_MATCHES:
        case LineActions.SUCCESS_REQUEST_FULL_LINE:
            return setMatchGroups(matches, groups);

        case LIVE_UPDATE.SUCCESS:
            return update(matches, groups, action.data);
    }

    return matches;
}

function update(matches, groups, data) {
    if (data.events !== undefined) {
        matches = setNewMatchesGroups(matches, groups, data.events.add);
    }

    if (data.outcomes !== undefined) {
        matches = updateMatchGroups(matches, groups, data.outcomes.remove);
        matches = updateMatchGroups(matches, groups, data.outcomes.add);
    }

    return matches;
}

function setMatchGroups(matches, groups) {
    const matchesArr = matches.toArray();

    for (let i = 0; i < matchesArr.length; i++) {
        matches = matches.setIn([matchesArr[i].get('id'), 'groups'], new List());
    }

    const groupArr = groups.toArray();
    for (let i = 0; i < groupArr.length; i++) {
        (group => {
            const matchId = group.get('matchId');
            const groupId = group.get('id');
            const groupType = group.get('type');

            if (groupType === 0) {
                matches = matches.updateIn([matchId, 'matchGroup'], () => groupId);
            } else {
                matches = matches.updateIn([matchId, 'groups'], m => m.push(groupId));
            }
        })(groupArr[i]);
    }

    return matches;
}

function setNewMatchesGroups(matches, groups, newMatches) {
    if (newMatches === undefined) {
        return matches;
    }

    for (let i = 0; i < newMatches.length; i++) {
        const matchId = newMatches[i].id;
        const matchGroups = groups.filter(g => g.get('matchId') === matchId);

        const defaultMatchGroup = matchGroups.find(mg => mg.get('type') === 0);
        const matchGroupIds = matchGroups.filter(mg => mg.get('type') !== 0).map(mg => mg.get('id'));

        matches = matches.setIn([matchId, 'matchGroup'], defaultMatchGroup ? defaultMatchGroup.get('id') : undefined);
        matches = matches.setIn([matchId, 'groups'], List(matchGroupIds));
    }

    return matches;
}

function updateMatchGroups(matches, groups, outcomes) {
    if (outcomes === undefined) {
        return matches;
    }

    const modifiedMatchIds = Array.from(new Set(outcomes.map(ro => ro.matchId)));

    for (let i = 0; i < modifiedMatchIds.length; i++) {
        const matchId = modifiedMatchIds[i];
        const matchGroups = groups.filter(g => g.get('matchId') === matchId);
        const defaultMatchGroup = matchGroups.find(g => g.get('type') === 0);
        const currentMatchGroupIds = matchGroups.filter(g => g.get('type') !== 0).map(g => g.get('id')).toList();

        matches = matches.setIn([matchId, 'matchGroup'], defaultMatchGroup ? defaultMatchGroup.get('id') : undefined);
        matches = matches.setIn([matchId, 'groups'], currentMatchGroupIds);
    }

    return matches;
}



// WEBPACK FOOTER //
// ./js/shared/reducers/entities/matchGroupsReducer.js